module.exports = __webpack_public_path__ + "static/hole-dfd66d39c1bb7f94784203ce5d65ee78.mp4";